export default {
  getSyndicationKeysForStream: (state) => (streamId) =>
    state.streamSyndicationKeys[streamId] || [],
};
